import React from "react";
import { useTranslation } from "react-i18next";

function JournalInfo({ doc }) {
  const { t } = useTranslation();
  return (
    <>
      <div>{t("requests.preview.journal.info.email")}: hkms@hkms.hr</div>
      <div>{t("requests.preview.journal.info.telephone")} 1: 01/2444-300</div>
      <div>{t("requests.preview.journal.info.telephone")} 2: 01/2444-303</div>
    </>
  );
}

export default JournalInfo;
